import { Turbo } from '@hotwired/turbo-rails'
import { StreamActions } from '@hotwired/turbo'

Turbo.session.drive = false

StreamActions.redirect = function () {
  console.log(this)
  const url = this.getAttribute('url')
  if (!url) return

  window.location.href = url
}

export const turbo = Turbo
